import { Card, CardProps } from "@mui/material";

type BlogCardOptionsModalWrapperProps = CardProps;

export const BlogCardOptionsModalWrapper = ({
  children,
  sx,
}: BlogCardOptionsModalWrapperProps) => {
  return (
    <Card
      sx={{
        ...sx,
        position: "absolute",
        bottom: "-50px",
        right: "0",
        zIndex: "3",
        width: "15rem",
        display: "flex",
        alignItems: "start",
        justifyContent: "start",
        paddingTop: "0.5rem",
        paddingBottom: "0.5rem",
      }}
    >
      {children}
    </Card>
  );
};
